<template>
	<div>
		<ReCardTask v-if="!$GVO.isEmpty(objTask)" :objTask="objTask" :objService="objService" class="taskStatus"/>
	</div>
</template>
<script>
import ReCardTask from "src/our_components/ReCardTask.vue";
import {eventEmitter} from "src/plugins/globalComponents.js";
export default {
	name: 'Task-page',
	components: {
		ReCardTask
	},
	data() {
		return {
			objTask: {},
			objService: {},
		};
	},
	methods: {
		getTask(){
			//console.log('getTask');
			const task_id = typeof this.$route.params.task_id == 'undefined'?'':this.$route.params.task_id;
			this.$GVO.ApiCall('GET_TASK',{obj:'services',flt:{id:task_id}})
			.then((objApi) => {
				if(objApi.success === true){
					//this.objTask = objApi.data[0];
					this.$GVO.ApiCall('GET_CONTAKCS',{obj:'client',flt:{id:objApi.data[0].client_id}})
					.then((objApiClientContacts) => {
						this.objTask = objApi.data[0];
						if(objApiClientContacts.success === true){
							let masPhones = [];
							for (let i = 0; i < objApiClientContacts.data.length; i++) {
								if(objApiClientContacts.data[i].contact_group == 'phone'){
									masPhones.push(objApiClientContacts.data[i].contact_value);
								}
							}
							this.objTask['client_phone_list'] = masPhones.join(',');
						}
					}).catch(errorObjApi => console.error(errorObjApi));
					this.$GVO.ApiCall('GET',{obj:'services',flt:{id:objApi.data[0].service_id}})
					.then((objApiServ) => {
						if(objApiServ.success === true){
							//console.log(objApiServ.data[0]);
							this.objService = objApiServ.data[0];
						}
					}).catch(errorObjApi => console.error(errorObjApi));
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
	},
	mounted() {
		this.getTask();
	},
	created(){
		eventEmitter.$on('reload_tasks', this.getTask);
		
	},
	beforeDestroy() {
		// Отписываемся от события
		eventEmitter.$off('reload_tasks', this.getTask);
	},
};
</script>
<style>
</style>
